import { BaseUrl } from "./config";
import axios from 'axios';
import { Notice } from 'view-design';
import Local from "../util/common/local";

// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    let parkInfo = Local.getLocal("park", "object") ? Local.getLocal("park", "object")[0] : null;

    if (parkInfo && typeof parkInfo == "object") config.headers['parkId'] = parkInfo.id + "";
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

export const send = function (type, url, data, expend) {
    var bindCompanies = JSON.parse(localStorage.getItem("bindCompanies")); // 用户企业信息
    var uuidList = bindCompanies ? bindCompanies : [];
    let uuid = "", uuids = ""; // 企业标识
    if (uuidList.length) {
        if (!uuidList[0]) {
            uuid = null
        } else {
            uuid = uuidList[0].uuid;
            uuidList.map(res => {
                uuids += res.uuid + ","
            });
        }
        uuids = uuids.substring(0, uuids.length - 1); // 清除最后一位逗号
    }
    data = data || {}; // 请求参数
    if (expend && typeof expend == "object") {
        data.content = data.content || {};
        for (let i = 0, length = expend.length; i < length; i++) {
            if (expend[i] == "uuid") {
                data.content.uuid = uuid;
            } else if (expend[i] == "uuids") {
                data.content.uuids = uuids;
            }
        }
    }
    if (expend[1]) {
        let tempUrl = url.split("/");
        tempUrl[2] = expend[1];
        url = tempUrl.join("/");
    }
    url = BaseUrl + url;
    switch (type) {
        case "GET": {
            data = setJson(data); // 返回promise对象
            if (data) {
                url += "?" + data;
            }
            return getHttp(url);
        }
        case "POST": {
            var formData = new FormData();
            for (let item in data) {
                formData.append(item, JSON.stringify(data[item]))
            }
            return postHttp(url, formData);
        }
        default: {
        }
    }
}

// get 方法参数设置
function setJson(parmas) {
    let json = "";
    if (parmas && typeof parmas == "object") {
        for (let item in parmas) {
            if (typeof parmas[item] == "object") {
                parmas[item] = JSON.stringify(parmas[item]);
            }
            let data = item + "=" + parmas[item] + "&";
            json += data;
        }
        json.substr(0, json.length - 1);
    }
    return encodeURI(json);
}


function getHttp(url) {
    return new Promise((resolve, reject) => {
        axios({
            method: 'get',
            url: url,
            withCredentials: true
        }).then(res => { // get接口请求成功
            if (res.data.code == 2) {
                Notice.warning({
                    title: "没有用户信息",
                    desc: "即将回到登录页面..."
                });
                Local.removeLocal(["user", "role", "bindCompanies"]);
                window.sessionStorage.clear();
                setTimeout(() => {
                    window.location.href = "/"; // 回到首页 
                }, 1000);
            } else {
                resolve(res.data);
            }
        }).catch((err) => {  // get接口请求失败
            Notice.error({
                title: "服务器异常",
                desc: "请尝试联系管理员"
            });
            reject(err);
        });
    })
}

function postHttp(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            withCredentials: true
        }).then(res => { // post接口请求成功
            if (res.data.code == 2) {
                Notice.warning({
                    title: "没有用户信息",
                    desc: "即将回到登录页面..."
                });
                Local.removeLocal(["user", "role", "bindCompanies"]);
                window.sessionStorage.clear();
                setTimeout(() => {
                    window.location.href = "/"; // 回到首页
                }, 1000);
            } else {
                resolve(res.data);
            }
        }).catch(err => { // post接口请求成功
            Notice.error({
                title: "服务器异常",
                desc: "请尝试联系管理员"
            });
            reject(err);
        })
    })
}

